import { render, staticRenderFns } from "./SubscriptionsList.vue?vue&type=template&id=2928a530&"
import script from "./SubscriptionsList.vue?vue&type=script&lang=js&"
export * from "./SubscriptionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SubscriptionsList.vue"
export default component.exports